<template>
  <div class="login">
    <img src="../../assets/logo_wwaw_square.png" height="200" width="200" alt="home-icon"/>
    <h3 id="intro">Sign In</h3>
    <input type="text" v-model="email" placeholder='Email'><br>
    <input type="password" v-model="password" placeholder='Password'><br>
    <button v-on:click="signIn">SUBMIT</button>
    <div class="my-4"><router-link to="/">Back To Main Site</router-link></div>
    <!--<p>You don't have an account? You can <router-link to="sign-up">create one.</router-link></p>-->
  </div>

</template>

<script>

  import {auth} from "../../firebaseConfig";

  export default {
    name: "login",
    data: function(){
      return {
        email:'',
        password:''
      }
    },
    methods:{
      signIn: function() {
        auth.signInWithEmailAndPassword(this.email,this.password).then(
          (user) => {
              this.$router.replace('hello')
          },
          (err) => {
            alert("oops" + err.message)
          }
        );
      }
    }
  }
</script>

<style scoped>

  .login{
    margin-top: 40px;
  }
  input{
    margin: 10px 0;
    width: 20%;
    padding:15px;
  }
  button{
    margin-top: 20px;
    width:10%;
    cursor:pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
  #intro {
    margin-top: 15px;
  }
  #logo {
    width: 150px;
  }
</style>
